<template functional>
  <footer class="site-footer" :class="classes">
    <div class="grey-section">
      <b-container>
        <b-row align-h="center">
          <b-col sm="3">
            <div class="h3 mb-2">
              <h6 class="mb-3">PLAN DU SITE</h6>
              <ul class="footer-links text-uppercase">
                <li class=""><b-link to="/">Accueil</b-link></li>
                <li>
                  <b-link to="/about-us">LA SO.BE.MA.P </b-link>
                </li>
                <li>
                  <b-link to="/resources">Moyens techniques</b-link>
                </li>
                <li>
                  <b-link to="/prestations">Prestations</b-link>
                </li>
                <li>
                  <b-link to="/actualites">Actualités</b-link>
                </li>
                <li>
                  <b-link to="/contact">Contacts</b-link>
                </li>
              </ul>
            </div>
          </b-col>

          <b-col sm="3">
            <div class="h3 mb-2">
              <h6 class="mb-3">ADRESSE</h6>
              <ul class="footer-links">
                <li>01 BP 35 Boulevard de la Marina</li>
                <li>Cotonou, République du Bénin</li>
              </ul>
            </div>
          </b-col>

          <b-col sm="3">
            <div class="h3 mb-2">
              <h6 class="mb-3">CONTACTS</h6>
              <ul class="footer-links">
                <li><a href="tel:+22955996382">(229) 55 99 63 82</a></li>
              </ul>
            </div>
          </b-col>

          <b-col sm="3">
            <div class="h3 mb-2">
              <h6 class="mail mb-3">ADRESSE ELECTRONIQUE</h6>
              <ul class="footer-links">
                <li><a href="mailto:sobemap@sobemap.com">sobemap@sobemap.com</a></li>
                <li><a href="mailto:dircomark@sobemap.com">dircomark@sobemap.com</a></li>
                <!-- <li class="mt-3">
                    <b-form-input class="transparent" />
                  </li> -->
              </ul>
            </div>
          </b-col>
        </b-row>
        <div class="text-center">
          <b-row align-h="center">
            <b-col cols="8">
              <div class=" mb-1" style="font-size: 1.5rem;">
                <span class="p-2">
                  <b-icon-facebook class="text-white" />
                </span>
                <span class="p-2">
                  <b-icon-twitter class="text-white" />
                </span>
                <span class="p-2">
                  <b-icon-linkedin class="text-white" />
                </span>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>

    <div class="p-2">
      <b-container>
        <b-row class="w-100">
          <b-col>
            <div class="h3 mb-2">
              <div class="d-flex flex-md-row justify-content-center align-items-center flex-sm-column">
                  <img src="@/assets/images/footer/ISO_45001_2018.png" height="78" width="78" alt="" srcset="">
                  <b-img src="@/assets/images/footer.png" fluid height="150" width="150" alt="" srcset="" />
                  <img class="ml-2" src="@/assets/images/footer/ISO_9001_2015.jpg" height="80" width="80" alt=""
                    srcset="">
              </div>
              <div>
                <div class="text-dark">
                  <span class="h6"><span class="text-dark text-uppercase font-weight-bold">Copyright</span> © SOBEMAP {{
                      new Date().getFullYear()
                  }}. Tous droits réservés.</span>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="">
      <b-container>
        <b-row>
          <b-col class="flag-green"></b-col>
          <b-col class="flag-yellow"></b-col>
          <b-col class="flag-red"></b-col>
        </b-row>
      </b-container>
    </div>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth
    }
  },
};
</script>


<style lang="scss">
.site-footer {
  font-size: 14px;
  line-height: 24px;
  color: #737373;
  width: 100%;
  flex-shrink: 0;
  background-color: white;

  @media (min-width: 990px) {
    position: absolute;
  }

}

.grey-section {
  padding: 40px 0 15px;
  background-color: #595959;
}

.white-section {
  padding-top: 20px;
  background-color: #fff;

}

.border-divider {
  border-left: 2px solid black;
  height: 75px;
}

.society-name {
  color: #006436;
}

.plan {
  text-align: left;
  padding-left: 20px;
}

.adress {
  text-align: justify;
  display: block;
  text-align: left;
  color: rgba(255, 255, 255, 0.842);

}

.flag {
  display: inline;
  width: 100%;
}

.flag-green {
  background-color: #006435;
  height: 10px;
  width: 100%;
}

.flag-yellow {
  background-color: #ffde00;
  height: 10px;
  width: 100%;
}

.flag-red {
  background-color: #ff0000;
  height: 10px;
  width: 100%;
}

.contact li {
  padding-left: 30px;
  text-align: center;
}

.site-footer hr {
  border-top-color: #bbb;
  opacity: 0.5;
}

.site-footer hr.small {
  margin: 20px 0;
}

.site-footer h6 {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
  margin-top: 5px;
  letter-spacing: 2px;
}

.site-footer a {
  color: #fff;
}

.site-footer a:hover {
  color: #ffde00;
  text-decoration: none;
}

.footer-links {
  padding-left: 0;
  list-style: none;
  line-height: 23px;
}

.footer-links li {
  display: block;
  color: rgba(255, 255, 255, 0.842);
  font-size: 14px;
  padding: 2px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.842);
}

.footer-links a:active,
.footer-links a:focus,
.footer-links a:hover {
  color: #FFF;
  font-weight: bold;
  text-decoration: underline;
}

.footer-links.inline li {
  display: inline-block;
}

@media (max-width: 991px) {
  .site-footer [class^="col-"] {
    margin-bottom: 30px;
  }
}

@media (max-width: 767px) {
  .site-footer {
    padding-bottom: 0;
  }
}
</style>